import React from 'react';
import Skeleton from 'react-loading-skeleton';

const InputMask = React.lazy(()=>import('react-input-mask'))
function MaskedInput({mask, value, onChange, autoComplete, id, name, type}) {
    if(mask){
        return  <React.Suspense fallback={<Skeleton height={36.5} />}>
            <InputMask mask={mask} maskChar={"_"}
                          onChange={onChange}
                          type={type} id={id} name={name} value={value}
                          autoComplete={autoComplete}
                          alwaysShowMask={true}
                          className={'form-control'}
               />
        </React.Suspense>
    }else{
        return <input type={type} id={id} name={name} value={value} onChange={onChange}
                      autoComplete={autoComplete}
                      className={'form-control'}
        />
    }
}

export default MaskedInput;
